import type {
  itemDependencySchema,
  scenarioItemMetricsSchema,
  scenarioItemSchema,
  scenarioItemUpdateWithRelativePriorityRequestSchema,
  timeLineDataSetSchema,
  timeLineItemSchema,
} from '@tempo-io/adaptive-planner-dto';
import type { z } from 'zod';

export const SchedulingValidation = {
  MissingTeam: 'MISSING_TEAM',
  EmptyTeam: 'EMPTY_TEAM',
  NoAvailability: 'NO_AVAILABILITY',
  TeamUnavailable: 'TEAM_UNAVAILABLE',
  MissingEstimation: 'MISSING_ESTIMATION',
  InvalidTargetDates: 'INVALID_TARGET_DATES',
  ItemIsDone: 'ITEM_IS_DONE',
  ParentUnschedulable: 'PARENT_UNSCHEDULABLE',
  DependencyUnschedulable: 'DEPENDENCY_UNSCHEDULABLE',
  CircularDependency: 'CIRCULAR_DEPENDENCY',
  OutsideCalendarLimits: 'OUTSIDE_CALENDAR_LIMITS',
  ParentIsDone: 'PARENT_IS_DONE',
} as const;

export type SchedulingValidation = (typeof SchedulingValidation)[keyof typeof SchedulingValidation];

export const TIMELINE_ITEM_IMPUTED_FIELD = {
  ESTIMATION: 'ESTIMATION',
  TEAM: 'TEAM',
} as const;

export type TimelineItemImputedField =
  (typeof TIMELINE_ITEM_IMPUTED_FIELD)[keyof typeof TIMELINE_ITEM_IMPUTED_FIELD];

export type ScenarioItem = z.infer<typeof scenarioItemSchema>;

export type ScenarioItemPatchRequest = z.infer<
  typeof scenarioItemUpdateWithRelativePriorityRequestSchema
>;

export type ScenarioItemMetrics = z.infer<typeof scenarioItemMetricsSchema>;

export type TimeLineDataSet = z.infer<typeof timeLineDataSetSchema>;

export type TimelineItemItemDependency = z.infer<typeof itemDependencySchema>;

export type BulkFetchTimelineItem = z.infer<typeof timeLineItemSchema>;
